import React from 'react';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { Button, Modal, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useCommonStore from 'store/common';
import useTranslate from 'hooks/useTranslate';

export const SuccessModal: React.FC<any> = () => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const { modalConfig = {}, hideCommonModal }: any = useCommonStore((state) => state);
	const successTitle = `Job ${modalConfig?.id ? 'Updated' : 'Posted'} Successfully!`;

	return (
		<Modal.Body>
			<Stack className="success-modal-content text-center mx-auto">
				<Image src={IMAGE_PATHS.SuccessGif} alt="success" loading="lazy" />
				<h2 className="fw-bold mb-0">{successTitle}</h2>
				<Button
					className="transparent-btn rounded-pill mx-auto mt-4"
					onClick={() => {
						navigate(`/`);
						hideCommonModal();
					}}
				>
					{translate('Common.goToHome')}
				</Button>
			</Stack>
		</Modal.Body>
	);
};
